// extracted by mini-css-extract-plugin
export default {"wrapper":"label_wrapper__fUdNK"};